import { Disclosure } from '@headlessui/react';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import MinusIcon from '../../../images/icon-minus-round.inline.svg';
import PlusIcon from '../../../images/icon-plus-round.inline.svg';

/**
 * @description Render memoized product options
 * @param {Object} props
 * @returns {JSX.Element} Memoized product options
 */
export const ProductOptions = memo(function MemoizedProductOptions(props) {
  const [features, setFeatures] = useState('');
  const [dimensions, setDimensions] = useState('');

  const { product } = props;

  let descriptionText =
    "We take sleep seriously. We study it. We measure it. We investigate its every aspect. We're experts in the mechanics of sleep. We understand the vital role sleep plays in the body's cycle of healing, growing and rejuvenating. DUX® High Performance Sleep Systems are the result of over 95 years of	research and development. Our component system provides an unrivaled level of ergonomic support, so you can experience significantly higher quality sleep.";

  let shippingText =
    'A DUXIANA representative will contact you within one business day of placing your order to arrange delivery. In most cases, we will deliver your bed within 10-15 business days. Some areas may have slightly longer delivery times.';

  const contactMessage =
    'If you have any questions regarding your delivery, please email customerservice@duxiana.com, or call 1-888-752-7204, Monday – Friday, 9am–5 pm CT.';

  useEffect(() => {
    const productDetail = document.createElement('div');

    productDetail.innerHTML = product.description.replaceAll(
      process.env.GATSBY_PUBLIC_BIGCOMMERCE_GLOBAL_SHOP_PATH_SSL_VARIABLE,
      process.env.GATSBY_PUBLIC_PRODUCTION_STORE_SITE_URL
    );

    const option1 = productDetail.getElementsByClassName('accordion-content-features')?.[0] || '';
    const option2 = productDetail.getElementsByClassName('accordion-content-dimensions')?.[0] || '';

    setFeatures(parse(option1?.innerHTML || ''));
    setDimensions(parse(option2.innerHTML || ''));
  }, [product]);

  product?.custom_fields?.forEach((item) => {
    if (item.name.toLowerCase().includes('shortdesc')) {
      descriptionText = item.value;
    }

    if (item.name.toLowerCase().includes('shipping')) {
      shippingText = item.value;
    }

    return;
  });

  return (
    <div className="mb-8 grid grid-cols-1 gap-8 sm:gap-12 md:grid-cols-2 md:gap-16 lg:gap-24">
      <p className="pdp-item-description">{descriptionText}</p>

      <div className="flex flex-col border-t">
        {features && features.length > 0 && (
          <div className="border-b">
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button
                    className={
                      'button-disclosure flex w-full justify-between px-4 py-3 md:px-6 ' + (open ? 'expanded' : '')
                    }
                  >
                    <span className="tracking-em-01 text-sm font-normal">FEATURES</span>
                    {open ? <MinusIcon /> : <PlusIcon />}
                  </Disclosure.Button>
                  <Disclosure.Panel className="px-4 pb-2 pt-4 text-xs font-normal md:text-sm">
                    {features}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        )}
        {dimensions && dimensions.length > 0 && (
          <div className="border-b ">
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button
                    className={
                      'button-disclosure flex w-full justify-between px-4 py-3 md:px-6 ' + (open ? 'expanded' : '')
                    }
                  >
                    <span className="tracking-em-01 text-sm font-normal">DIMENSIONS</span>
                    {open ? <MinusIcon /> : <PlusIcon />}
                  </Disclosure.Button>
                  <Disclosure.Panel className="px-4 pb-2 pt-4 text-xs font-normal md:text-sm">
                    {dimensions}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        )}

        <div>
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button
                  className={
                    'button-disclosure flex w-full justify-between px-4 py-3 md:px-6 ' + (open ? 'expanded' : '')
                  }
                >
                  <span className="tracking-em-01 text-sm font-normal">SHIPPING</span>
                  {open ? <MinusIcon /> : <PlusIcon />}
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pb-2 pt-4 text-xs font-normal md:text-sm">
                  <p>
                    {shippingText} <br />
                    <br />
                    {contactMessage}
                  </p>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>
    </div>
  );
});

ProductOptions.propTypes = {
  product: PropTypes.shape({
    custom_fields: PropTypes.array,
    description: PropTypes.string
  })
};
